import React from 'react';
import { FormFeedback } from '@morressier/alembic';
import {
  getValidationTypedMessage,
  validationErrorMessages
} from './errorMessages';

import { useFormContext, FieldError } from 'react-hook-form';
import { get } from 'lodash';
import { ValidationKindTypes } from '@publishing-engine/domain/types/article';
import { ValidationKind } from '@publishing-engine/domain/types/article';

interface FormFieldErrorMessageProps {
  config: {
    params: {
      validations: ValidationKind;
      labels: {
        main: string;
      };
    };
    caseDataFields: {
      main: string;
    };
  };
  /**
   * Optional label override. Defaults to `labels.main`. Dependent fields pass
   * the inner textarea/input label (e.g. `labels.section.title`) so that
   * validation errors on the textarea reference it rather than the main field.
   */
  label?: string;
}

const FormFieldErrorMessage: React.FC<FormFieldErrorMessageProps> = ({
  config,
  label
}) => {
  const {
    caseDataFields: { main },
    params: { validations, labels }
  } = config;

  const {
    formState: { errors }
  } = useFormContext();
  const error = get(errors, main) as FieldError;

  if (!error) return null;

  const fieldName = label ?? labels.main;

  const kind = validations.kind as ValidationKindTypes;
  const messageFunction = validationErrorMessages[kind];

  if (!messageFunction) {
    return (
      <FormFeedback variant="error">
        Please enter a valid {fieldName}
      </FormFeedback>
    );
  }

  return (
    <FormFeedback variant="error">
      {getValidationTypedMessage(fieldName, kind, validations, error)}
    </FormFeedback>
  );
};

export default FormFieldErrorMessage;
